module.exports = __webpack_public_path__ + "static/images/trending-down.c4b7cf24fa72c74b0b51de7502b034e6.svg";